/**
 * Overrides the client sheet's tables apply to the shared Table primitives:
 * flush left inside a section card, a compact header, and tighter rows.
 */
export const SHEET_TABLE_HEAD =
  'text-muted-foreground h-auto px-0 pr-2.5 pb-1.5 text-xs last:pr-0'
export const SHEET_TABLE_CELL = 'px-0 py-2 pr-2.5 last:pr-0'
